/**
 * User: herbert
 * Date: 19.04.16
 * Time: 11:23
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

import React from 'react';

import {
	PART_ELEMENT_GOBO_NAME,
	PART_ELEMENT_FASSADE_500_NAME,
	PART_ELEMENT_TWINSPOT_NAME,
	PART_ELEMENT_VERT_NAME,
	PART_MODUL_CHARGING_NAME, zoomPath
} from '../../../../config.js';

import steleSVG from '../../SteleSVG.js';

/* eslint react/no-multi-comp: 0 */

function parentPart(k, i, part, parentRotation, children, storeRef, zoom, datasheet) {
	const imgName = part.name + (part.sky ? 'sky' : '') + (part.gold ? '_gold' : '');
	return (<div key={k} ref={storeRef ? storeRef + '-' + i : null}
	             className={'slx-stele__' + part.name + (part.temporary ? ' slx-stele__temporary' : '')} >
		<img key={k + '-img'}
			 src={zoom ? zoomPath + imgName + '.png' : steleSVG.getPart(imgName, datasheet ? 0 : (parentRotation + part.rotation) % 360, (part.backCover ? 2 : 1))}
		     />
		<div key={k + '-spacer'} className={'slx-stele__' + part.name + '-spacer'} />
		{children}
	</div>);
}

function childPart(k, i, j, part, parentRotation, storeRef, zoom, datasheet) {
	const refName = storeRef + '-' + (j !== null ? j + '-' + i : i);
	const imgName = (part.name === PART_MODUL_CHARGING_NAME && !zoom ? PART_MODUL_CHARGING_NAME + '1' : part.name) +
		(part.sky ? 'sky' : '') + (part.gold ? '_gold' : '');
	//if(storeRef !==null)
	//	console.log("childPart "+k+", "+ i+", "+ j+", "+ part.name, storeRef, j, refName);
	return (<img key={k} ref={storeRef ? refName : null}
	             className={'slx-stele__' + part.name + (part.temporary ? ' slx-stele__temporary' : '')}
				 src={zoom ? zoomPath + imgName + '.png' : steleSVG.getPart(imgName, datasheet ? 0 : parentRotation)}
			/>);
}

/**
 *
 * @param{Array.<StelePart>} parts SteleParts to render
 * @param{string} key React key to identify elements
 * @param{?Number} j  parent position in parent array if applicable, else null
 * @param{?Number} parentRotation  rotation of parent if applicable, else null
 * @param{?Boolean} parentBackCover backCover property of parent if applicable, else null
 * @param{string} [storeRef] first part of ref-string to store refs to parent and child elements
 * @param{Boolean} [zoom] if true render with zoom images instead of svgs
 * @param{Boolean} [datasheet] if true render without rotating parts
 * @returns{JSX} rendered markup
 */
function mapParts(parts, key, j, parentRotation, parentBackCover, storeRef, zoom, datasheet) {
	if(storeRef === true)
		storeRef = 'st';

	// das jeweils neu berechnen des vorher benötigten platzes ist nicht nur unnötig rechenintensiv, sondern auch zu
	// kompliziert daher vergiften wir hier die Objekte mit einem extra-feld, da hoffentlich nur hier benutzt wird
	let nextPosition = 0;
	for(let a=0; a < parts.length; a++) {
		// gibt es mindestens einen spacer? -> f500 passt an der vorhergesehen stelle
		if (parts[a].position > nextPosition)
			parts[a].jsxSpacer = parts[a].position - nextPosition;
		else
			parts[a].jsxSpacer = 0;

		nextPosition = Math.max(nextPosition, parts[a].position) +
			(parts[a].jsxSpacer === 0 ?
						(
							(parts[a].name.substr(0, 4) === PART_ELEMENT_FASSADE_500_NAME || parts[a].name === PART_ELEMENT_GOBO_NAME) ?
							((a>0 && (parts[a-1].name === PART_ELEMENT_TWINSPOT_NAME || parts[a-1].name === PART_ELEMENT_VERT_NAME)) ? 3 : 2) : // TODO müsste hier nicht auch der Speaker stehen?
							1
						) :
						(
							(parts[a].name.substr(0, 4) === PART_ELEMENT_FASSADE_500_NAME || parts[a].name === PART_ELEMENT_GOBO_NAME) ?
							2 :
							1
						)
			);
	}

	return parts.map( (/**StelePart*/ part, i) => {
		const k = j !== null ? '' + key + '.' + j + '.' + i : '' + key + '.' + i;
		let ret = null;
		if(part.container) {
			const childs = mapParts(part.children, key, i, (parentRotation + part.rotation) % 360, part.backCover, storeRef, zoom, datasheet);
			ret = parentPart(k, i, part, parentRotation, childs, key !== null ? storeRef : null, zoom, datasheet);
		} else {
			// zwischen 90° und 270° Grad sieht man nur die Seite/Abdeckung, 90° und 270° sind leer, weil von der Seite
			if(parentBackCover && parentRotation >= 90 && parentRotation <= 270)
				parentRotation = 90;
			ret = [];
			let p = part.jsxSpacer;
			while(p > 0) {
				ret.push(<div key={k + '-spacer250-' + p} className="slx-stele__spacer250" />);
				p--;
			}
			ret.push(childPart(k, i, j, part, parentRotation, key !== null ? storeRef : null, zoom, datasheet));
		}
		return ret;
	});
}

export default mapParts;
